import React from 'react';
import { t, defineMessages } from '@sm/intl';
import { createURL } from '@sm/utils';
import { TopBarSlim } from '../TopBarSlim';
import { UseCaseVariationEnums } from '../TopBarSlimEnums';

const DEFAULT_COPY = defineMessages({
  MESSAGE: {
    id: 'UseCaseAcademicResearchTopBarSlim.message',
    defaultMessage:
      'Get better research data with survey logic, A/B tests, and more question types.',
    description: '[Type: Paragraph][Vis.: low] - Top bar slim message',
  },
  CTA_TEXT: {
    id: 'UseCaseAcademicResearchTopBarSlim.ctaText',
    defaultMessage: 'See plan options',
    description: '[Type: Button][Vis.: low] - Top bar slim cta text',
  },
});

const COLLECT_COPY = defineMessages({
  MESSAGE: {
    id: 'UseCaseAcademicResearchTopBarSlim.messageCollect',
    defaultMessage:
      'Reach your target audience from around the globe with SurveyMonkey Audience.',
    description: '[Type: Paragraph][Vis.: low] - Top bar slim message',
  },
  CTA_TEXT: {
    id: 'UseCaseAcademicResearchTopBarSlim.ctaTextCollect',
    defaultMessage: 'Buy responses',
    description: '[Type: Button][Vis.: low] - Top bar slim cta text',
  },
});

const ANALYZE_COPY = defineMessages({
  MESSAGE: {
    id: 'UseCaseAcademicResearchTopBarSlim.messageAnalyze',
    defaultMessage:
      'Get deeper analysis with crosstabs, SPSS & XLS exports, and stat testing.',
    description: '[Type: Paragraph][Vis.: low] - Top bar slim message',
  },
  CTA_TEXT: {
    id: 'UseCaseAcademicResearchTopBarSlim.ctaTextAnalyze',
    defaultMessage: 'See plans and features',
    description: '[Type: Button][Vis.: low] - Top bar slim cta text',
  },
});

export type UseCaseAcademicResearchTopBarSlimProps = {
  variation?: UseCaseVariationEnums | null;
};

const VariationToCopy = {
  [UseCaseVariationEnums.create]: DEFAULT_COPY,
  [UseCaseVariationEnums.collect]: COLLECT_COPY,
  [UseCaseVariationEnums.analyze]: ANALYZE_COPY,
};

const VariationToPath = {
  [UseCaseVariationEnums.create]: '/pricing/upgrade/',
  [UseCaseVariationEnums.collect]: '/collect/audience/preview',
  [UseCaseVariationEnums.analyze]: '/pricing/upgrade/',
};

export const UseCaseAcademicResearchTopBarSlim: React.FC<UseCaseAcademicResearchTopBarSlimProps> = ({
  variation,
}) => {
  const copy =
    variation && variation in VariationToCopy
      ? VariationToCopy[variation]
      : DEFAULT_COPY;
  const path = variation ? VariationToPath[variation] : '/pricing/upgrade/';
  const ut_source = variation
    ? `slim_${variation}_upsell_academic_research`
    : 'slim_create_upsell_academic_research';

  return (
    <TopBarSlim
      message={t(copy.MESSAGE)}
      ctaText={t(copy.CTA_TEXT)}
      ctaLink={createURL(path, {
        ut_source: 'topbar',
        ut_source2: ut_source,
      })}
      ctaNewTab
    />
  );
};

export default UseCaseAcademicResearchTopBarSlim;
